import { useState } from 'react';
import { faqItems } from '@/mocks/faq';

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqItems.map((item) => ({
    "@type": "Question",
    "name": item.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": item.answer
    }
  }))
};

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <section className="w-full py-16 md:py-20 bg-background-100">
        <div className="w-full px-6 md:px-10 max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4">
              FAQ
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              Frequently Asked Questions
            </h2>
            <p className="text-foreground-600 text-sm md:text-base">
              Find answers to the most common questions about VigorBuy Spreadsheet.
            </p>
          </div>

          <div className="flex flex-col gap-3">
            {faqItems.map((item, idx) => (
              <div
                key={idx}
                className="rounded-xl border border-background-200 bg-background-50 overflow-hidden"
              >
                <button
                  onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                >
                  <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                    {item.question}
                  </span>
                  <span
                    className={`w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full transition-all ${
                      openIdx === idx
                        ? 'bg-primary-500 text-white rotate-45'
                        : 'bg-background-200 text-foreground-500'
                    }`}
                  >
                    <i className="ri-add-line text-sm"></i>
                  </span>
                </button>
                <div
                  className={`transition-all duration-300 overflow-hidden ${
                    openIdx === idx ? 'max-h-96 pb-5' : 'max-h-0'
                  }`}
                >
                  <p className="px-5 text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}